import React, { useState } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/Footer/Footer";

import "./BankTime.scss";

import Progress from "../../../components/Progress/Progress";
import ScrollToTop from "../../../components/ScrollToTop/ScrollToTop";
import checkedIcon from "../../../assets/images/checked.png";
import BankTimeIcon from "../../../assets/images/step-icon/banktime-icon.png";

import { StepPreFooter } from "../../../components/Footer/StepPreFooter";
import { useLocation } from "react-router-dom";
import { getPrevStepLink } from "../../../utils/functions";

import { useForm } from "react-hook-form";
import { updateContact } from "../../../redux/apiCalls";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { StepBtn } from "../../../components/Button/StepBtn/StepBtn";
import { currentBankDurationOptions } from "../../../utils/options";
import { nextStepDelayTime } from "../../../utils/const";

const BankTime = () => {
  const [loadingButton, setLoadingButton] = useState(false);

  const windowWidth = window.innerWidth;
  const isMobile = windowWidth < 768;

  const contactRedux = useSelector((state) => state?.contact?.contact);
  const [currentBankDuration, setCurrentBankDuration] = useState(
    contactRedux?.bankAccountLengthMonths ?? contactRedux?.currentBankDuration ?? ""
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const currentLoc = useLocation();
  const prevLink = getPrevStepLink(currentLoc.pathname);

  const {
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors }
  } = useForm();
  const onSubmit = async () => {
    if (!currentBankDuration) {
      setError("currentBankDuration", {
        type: "error",
        message: "Please choose an answer"
      });
      return;
    }

    setLoadingButton(!loadingButton);

    const lead_id = sessionStorage.getItem("lead_id");
    const res = await updateContact(dispatch, contactRedux?._id, {
      step: 20,
      lead_id,
      bankAccountLengthMonths: currentBankDuration
    });

    if (res?.status === 200) {
      setTimeout(() => {
        setLoadingButton(false);
        navigate("/bankaccount");
      }, nextStepDelayTime);
    }
  };

  return (
    <Box className="BankTime-page">
      <Navbar />
      <ScrollToTop />
      <Box
        sx={{
          width: "100%",
          maxWidth: "700px",
          margin: "20px auto"
        }}
      >
        <div className="step-main">
          <form className="step-form" onSubmit={handleSubmit(onSubmit)}>
            <Box
              sx={{
                width: "100%",

                margin: "10px auto 30px",
                padding: isMobile && "0 15px"
              }}
            >
              <Progress step={19} />
            </Box>
            <Box sx={{ textAlign: "center", marginBottom: "11px" }}>
              <img
                style={{
                  maxWidth: isMobile && "42px"
                }}
                src={BankTimeIcon}
                alt=""
              />
            </Box>
            <h2 className="title">Length of Bank Account</h2>
            <h5>How long have you had this bank account opened for?</h5>

            <div className="form-control">
              <div className="list-btn-radio">
                {currentBankDurationOptions.map((option, index) => (
                  <button
                    key={index}
                    className={`btn-radio ${
                      currentBankDuration === option.value ? "active" : ""
                    }`}
                    onClick={(e) => {
                      setCurrentBankDuration(option.value);
                      clearErrors("currentBankDuration");
                    }}
                  >
                    {option.label}
                    {currentBankDuration === option && (
                      <img className="checked-icon" src={checkedIcon} alt="" />
                    )}
                  </button>
                ))}
              </div>

              {errors?.currentBankDuration && (
                <span
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "10px",
                    display: "block",
                    textAlign: "center"
                  }}
                  className="error"
                >
                  {errors?.currentBankDuration?.message}
                </span>
              )}
            </div>

            <Box
              sx={{
                maxWidth: "474px",
                margin: "0 auto"
              }}
            >
              <StepBtn
                prevLink={prevLink}
                onSubmit={handleSubmit(onSubmit)}
                loading={loadingButton}
              />
            </Box>
          </form>
          <StepPreFooter />
        </div>
      </Box>
      {/* <Footer desc={false} /> */}
    </Box>
  );
};

export default BankTime;
